import { call, takeLatest } from "redux-saga/effects";
import { Actions } from "../constants/actionTypes";
import {
  apiCreateblueprints,
  apiDeleteBluePrint,
  apiRenameBlueprints,
  apiGetAllBlueprints,
  apiGetAllSpecificBlueprints,
  apiIsValidBlueprintName,
  apiImageUploadBluePrint,
  apiRemoveBluePrintImage,
} from "../Services/bluePrint/bluePrintAPI.js";

export function* apiCreateBlueprint() {
  yield takeLatest([Actions.API_CREATE_BLUEPRINT], createBlueprint);
}

function* createBlueprint(action) {
  const result = yield call(apiCreateblueprints, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* apiDeleteBlueprint() {
  yield takeLatest([Actions.API_DELETE_BLUEPRINT], deleteBlueprint);
}

function* deleteBlueprint(action) {
  const result = yield call(apiDeleteBluePrint, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* apiRenameBlueprint() {
  yield takeLatest([Actions.API_RENAME_BLUEPRINT], renameBlueprint);
}

function* renameBlueprint(action) {
  const result = yield call(apiRenameBlueprints, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* apiGetAllBlueprint() {
  yield takeLatest([Actions.API_GET_ALL_BLUEPRINT], allBlueprint);
}

function* allBlueprint(action) {
  const result = yield call(apiGetAllBlueprints, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* getAllSpecificBlueprints(action) {
  yield takeLatest(
    [Actions.API_GET_ALL_SPECIFIC_BLUEPRINT],
    allSpecificBlueprint
  );
}

function* allSpecificBlueprint(action) {
  const result = yield call(apiGetAllSpecificBlueprints, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* apiIsValidBluePrintName(action) {
  yield takeLatest(
    [Actions.API_IS_VALID_BLUEPRINT_NAME],
    apiIsValidBlueprintNames
  );
}

function* apiIsValidBlueprintNames(action) {
  const result = yield call(apiIsValidBlueprintName, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess(result.data);
  } else {
    action.meta?.onError();
  }
}

export function* apiImageUploadBp() {
  yield takeLatest(
    [Actions.API_IMAGE_UPLOAD_BLUEPRINT],
    apiImageUploadBlueprint
  );
}

function* apiImageUploadBlueprint(action) {
  const result = yield call(apiImageUploadBluePrint, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* apiRemoveBlueprintImage() {
  yield takeLatest([Actions.API_REMOVE_BLUEPRINT_IMAGE], apiRemoveBpImage);
}

function* apiRemoveBpImage(action) {
  const result = yield call(apiRemoveBluePrintImage, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}
